/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{addUniqueItem as i,removeItem as r}from"../../utils/array.js";import{compareByDepth as t}from"./compare-by-depth.js";class s{constructor(){this.children=[],this.isDirty=!1}add(r){i(this.children,r),this.isDirty=!0}remove(i){r(this.children,i),this.isDirty=!0}forEach(i){this.isDirty&&this.children.sort(t),this.isDirty=!1,this.children.forEach(i)}}export{s as FlatTree};
//# sourceMappingURL=flat-tree.js.map
